// extracted by mini-css-extract-plugin
export var borderRadius = "_aq-4";
export var large = "_aq-3";
export var logoContainer = "_aq-0";
export var nameLogo = "_aq-2";
export var small = "_aq-1";